import { FormattedMessage } from 'react-intl';
import { FormikPoolDatePicker, PoolTypography } from '@synergy/components';
import { Grid } from '@mui/material';
import { PaloFormSection } from '@synergy/components-palo';
import { fields } from '@synergy/utils';

import { SupplierSpecialOffersOverviewFormValues } from '../models/supplier-special-offers-overview-form-values';
import { selectedLanguageSelector } from '../../../../../../common/selectors/selected-language-selectors';
import { useAppSelector } from '../../../../../../store/use-appstate-selector';

export const SupplierSpecialOffersDetailOverviewDates = () => {
    const currentLocale = useAppSelector(state => state.currentLocale);
    const selectedLanguage = useAppSelector(selectedLanguageSelector);
    const fieldNames = fields<SupplierSpecialOffersOverviewFormValues>();

    return (
        <PaloFormSection title={<FormattedMessage id="app.contentManagement.supplierSpecialOffers.displayTime" />}>
            <Grid container={true} spacing={2}>
                <Grid item={true} xs={6}>
                    <FormikPoolDatePicker
                        name={fieldNames.validFrom}
                        label={
                            <FormattedMessage id="app.contentManagement.supplierSpecialOffers.displayTimeValidFrom" />
                        }
                        disablePast={true}
                        required={true}
                        readOnly={selectedLanguage !== currentLocale}
                    />
                </Grid>

                <Grid item={true} xs={6}>
                    <FormikPoolDatePicker
                        name={fieldNames.validTo}
                        disablePast={true}
                        label={<FormattedMessage id="app.contentManagement.supplierSpecialOffers.displayTimeValidTo" />}
                        required={true}
                        readOnly={selectedLanguage !== currentLocale}
                    />
                </Grid>
            </Grid>
        </PaloFormSection>
    );
};
